import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// THE SOCIAL LAYER — self-identifying, follows the player across every screen.
// Mark is PASSED IN rather than imported by IEFriends, so titles without the
// achievement stack can still carry the friends list. See IEFriends.js.
import IESocialDock from './IEFriends';
import Mark from './Mark';
// THE RAIL — seats the Friends pill + panel inside the backdrop band when one
// is up (Plaza / wrapped rooms, desktop). Off the band it is the plain dock.
import { RailFriendsDock } from './railDock';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './pwa'; // M10 — production only; see pwa.js
// SHIP 8 — THE REVIEW ROOM. `?stage=bodies` opens the standing-being
// stage instead of the game (BodiesStage.js). No game state, no Firebase.
import BodiesStage, { FieldStage } from './BodiesStage';
// PLAZA 3D — THE FOLK REVIEW ROOM. `?stage=folk&who=vael` puts the real
// art beside the 3D body (PlazaFolkStage.js). No game state, no Firebase.
import PlazaFolkStage from './PlazaFolkStage';
// KING'S GRACE — THE GRACE REVIEW ROOM. `?stage=graces` shows every Grace,
// flat and 3D, on one companion (GraceStage.jsx). No game state, no Firebase.
import GraceStage from './GraceStage';
// THE FORGE REVIEW ROOM. `?stage=forge` mounts the real Willie's Workshop
// with a stand-in profile, to walk the 3D Forge (ForgeStage.js). No Firebase.
import ForgeStage from './ForgeStage';

const STAGE = (() => {
  try { return new URLSearchParams(window.location.search).get('stage'); }
  catch (_) { return null; }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {STAGE === 'bodies' ? <BodiesStage /> : STAGE === 'field' ? <FieldStage /> : STAGE === 'folk' ? <PlazaFolkStage /> : STAGE === 'graces' ? <GraceStage /> : STAGE === 'forge' ? <ForgeStage /> : (<>
      <App />
      <RailFriendsDock Dock={IESocialDock} game="terror" accent="#a78bfa" MarkView={Mark} />
    </>)}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// M10 — installable, offline-capable, push-less by principle.
// A no-op in development, deliberately and loudly: see pwa.js.
registerServiceWorker();
